export function nameOf({pseudoFirstName, pseudoLastName}){
  if (!pseudoFirstName) return pseudoLastName
  else if (!pseudoLastName) return pseudoFirstName
  else return `${pseudoFirstName} ${pseudoLastName}`
}

export function sortNameOf({pseudoFirstName="", pseudoLastName=""}) {
  var name = pseudoLastName || ""
  if (name.length > 0){
    if (pseudoFirstName && pseudoFirstName.length > 0) {
      return (name + " " + pseudoFirstName).toLocaleLowerCase()
    } else {
      return name.toLocaleLowerCase()
    }
  } else {
    return (pseudoFirstName || "").toLocaleLowerCase()
  }
}


/** WEBPACK FOOTER **
 ** ./src/profile/utils.js
 **/